import { render, staticRenderFns } from "./detailsCenter.vue?vue&type=template&id=197bebcd&scoped=true&"
import script from "./detailsCenter.vue?vue&type=script&lang=js&"
export * from "./detailsCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bebcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197bebcd')) {
      api.createRecord('197bebcd', component.options)
    } else {
      api.reload('197bebcd', component.options)
    }
    module.hot.accept("./detailsCenter.vue?vue&type=template&id=197bebcd&scoped=true&", function () {
      api.rerender('197bebcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/detailsCenter.vue"
export default component.exports